<template>
	<div class="button-view" @click="$emit('click', $event)">
		<slot />
	</div>
</template>

<script>
	export default {
		name: 'button-view'
	}
</script>

<style lang="scss" scoped>
	.button-view {
		height: 40px;
		line-height: 40px;
		padding: 0 40px 0 40px;
		background-color: #f7223f;
		color: #fff;
		text-align: center;
		border-radius: 3px;
	}
</style>